import { GQLProductFragment, GQLProductSideAvailableDecorationType, GQLProductSideFragment } from '@theprintbar/graphql';

export function getArtboardWidthAndHeight(side: Pick<GQLProductSideFragment, 'printWidth' | 'printHeight'>) {
	return {
		width: side.printWidth || 0,
		height: side.printHeight || 0,
	};
}

export function getDefaultDecorationType(product: Pick<GQLProductFragment, 'sides'>) {
	return product.sides[0].availableDecorations[0] || GQLProductSideAvailableDecorationType.Dtg;
}

export function getSortedDecorationTypes(side?: GQLProductSideFragment) {
	return side?.availableDecorations || [];
}
